import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { startChat } from '../../lib/chat/startChat';
import { useLibraryItemFiles } from './hooks';
const OFFICE = /\.(docx|dotx|docm|xlsx|xltx|xlsm|pptx|potx|pptm)$/i;
/** The prompt that starts a document from a template in chat. */ export function templatePrompt(title, id) {
    return `Start a new document from our template "${title}" (template id ${id}). Ask me what it's for if you need to, then fill in its placeholders.`;
}
/**
 * The file a template or asset carries, and for an Office template a way to
 * start a document from it in chat (the assistant copies it into Documents
 * and fills its placeholders).
 */ export function LibraryItemFile({ itemId, title }) {
    const files = useLibraryItemFiles(itemId);
    const navigate = useNavigate();
    const file = files.data?.[0];
    if (!file) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-wrap items-center gap-2 text-xs",
        "data-testid": Testids.library.resultFile,
        children: [
            /*#__PURE__*/ _jsx(FileText, {
                className: "h-3.5 w-3.5 text-muted-foreground",
                "aria-hidden": true
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "truncate",
                children: file.label || 'Attached file'
            }),
            OFFICE.test(file.label) && /*#__PURE__*/ _jsx(SpecraButton, {
                size: "sm",
                variant: "secondary",
                "data-testid": Testids.library.useTemplateButton,
                onClick: ()=>startChat(navigate, templatePrompt(title, itemId)),
                children: "Start a document from it"
            })
        ]
    });
}
